<template>
    <div>
        <table class="table table-responsive table-hover raised">
            <thead>
            <tr>
                <th>
                    <div class="details-expander">
                        <i class="fa fa-caret-right" v-show="!showAll" @click="showAllDetails"></i>
                        <i class="fa fa-caret-down" v-show="showAll" @click="showNoDetails"></i>
                    </div>
                </th>
                <th nowrap v-for="(column, index) in columns">
                    <div class="cell-content"> {{ column.label }}</div>
                    <div class="column-separator"></div>
                </th>
            </tr>
            </thead>
            <tbody>

            <template v-for="(row, index) in rows">
                <tr @click="toggleDetails(index)" v-if="index<rows.length && index < items_per_page">
                    <td>
                        <div class="details-expander" v-if="index< (rows.length-1)">
                            <i class="fa fa-caret-right" v-show="!showingDetails(index)"></i>
                            <i class="fa fa-caret-down" v-show="showingDetails(index)"></i>
                        </div>
                    </td>

                    <td v-for="column in columns" nowrap>
                            <span v-if="column.column_nm == 'password'">
                                { encrypted data }
                            </span>
                        <span v-else>
                                {{ row[column.column_nm] }}
                            </span>
                    </td>
                </tr>

                <tr class="details expanded" v-if="showingDetails(index) && changeDetected(index)">
                    <td></td>
                    <td colspan="6">
                        <div>
                            <table class="table table-condensed">
                                <thead>
                                <tr>
                                    <th>Column Name</th>
                                    <th>New Value</th>
                                    <th>Old Value</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="column in columns">
                                    <tr v-show="!(rows[index][column.column_nm] == rows[index + 1][column.column_nm])
                                            && displayColumnChange(column.column_nm)">

                                        <td>
                                            {{ column.label }}
                                        </td>
                                        <td v-if="column.column_nm == 'password'">
                                            { encrypted data }
                                        </td>
                                        <td v-else>
                                            {{ rows[index][column.column_nm] }}
                                        </td>
                                        <td v-if="column.column_nm == 'password'">
                                            { encrypted data }
                                        </td>
                                        <td v-else>
                                            {{ rows[index + 1][column.column_nm] }}
                                        </td>
                                    </tr>
                                </template>
                                </tbody>
                            </table>
                        </div>
                    </td>
                </tr>
            </template>


            </tbody>

        </table>
    </div>


</template>


<script>
    export default{
        data: function() {
            return {
                row_index: 0,
                expanded: [],
                showAll: false,
                items_per_page: 25
            }
        },

        props: {
            'limit' : {
                default: function() { return []; }
            },
            'rows' : {
                default: function() { return []; }
            },

            'columns' : {
                default: function() { return []; }
            },
            'activity_type' : {default: ''},
        },

        computed: {

        },

        methods: {
            displayColumnChange: function(column_nm){
                switch (column_nm) {
                case 'BAK$created_at':
                case 'operation':
                case 'update_ts':
                case 'updating_email':
                case 'account_nbr':
                case 'user_id':
                    return false;
                    break;
                default:
                    return true;
                }

            },

            lastRecord: function (index) {

                switch (this.activity_type) {
                case 'user_roles':
                    if ((this.rows[index]['account_nbr'] == this.rows[index+1]['account_nbr'])
                        && (this.rows[index]['user_id'] == this.rows[index+1] ['user_id']))
                    {
                        return false;
                    }
                    break;
                case 'user':
                if (this.rows[index]['user_id'] == this.rows[index+1] ['user_id'])
                    {
                        return false;
                    }
                    break;
                }
                return true;
            },

            changeDetected: function(index) {

                if (index == (this.rows.length - 1)) {
                    return false;
                }
                if (this.lastRecord(index)) {
                    return false;
                }

                for (var i = 0; i < this.columns.length; i++)
                {
                    var column_nm = this.columns[i].column_nm

                    if (this.displayColumnChange(column_nm)
                        && (this.rows[index][column_nm] != this.rows[index + 1][column_nm]))
                    {
                        return true;
                    }
                }
                return false;
            },
            showingDetails: function(row_index) {
                return this.expanded.includes(row_index)
            },
            toggleDetails: function (row_index) {
                if (this.showingDetails(row_index)) {
                    this.expanded.splice(this.expanded.indexOf(row_index),1)
                    this.showAll = false;
                }
                else {
                    this.expanded.push(row_index)
                }
            },
            showAllDetails: function() {
                this.showAll=true;
                for (var index = 0; index < this.rows.length; index++)
                {
                    if (!this.showingDetails(index)) {
                        this.expanded.push(index);
                    }
                }
            },
            showNoDetails: function() {
                this.expanded =[];
                this.showAll=false
            }
        },

    }

</script>



// WEBPACK FOOTER //
// change-list.vue?57482aa4